document.addEventListener('DOMContentLoaded', function () {
  const footerTaget = document.getElementById('shopify-section-section-footer');
  // get the target element for the lightbox script
  const target = document.getElementById('performance-target')
  // get the cordial newsletter id from the global namespace
  const cordial_newsletter_id = __GLOBAL__.integrations.cordialVendorID;

  const lightBoxScript = document.createElement('script')
  lightBoxScript.type = 'text/javascript'
  lightBoxScript.async = true
  lightBoxScript.src = `https://forms.p.lauramercier.com/w37htfhcq2/vendor/${cordial_newsletter_id}/lightbox_speed.js`

  const injectFooterSignUpScript = () => {
    // inject the lightbox script
    target?.insertBefore(lightBoxScript, null);
  }

  const options = {
    root: null,
    threshold: 0.5
  };

  const callback = function(entries, observer) {
    if(cordial_newsletter_id != undefined)
    entries.forEach((entry) => {
      if (entry.isIntersecting && cordial_newsletter_id) {
        injectFooterSignUpScript()
      }
    });
  }

  let observer = new IntersectionObserver(callback, options);
  observer.observe(footerTaget);
})
